const config = require("app/util/config/config");

const propTypes = {
  loading: React.PropTypes.bool.isRequired,
  failed: React.PropTypes.bool,
  onRetry: React.PropTypes.func,
  children: React.PropTypes.node.isRequired
};

const defaultProps = {
  failed: false,
  onRetry: () => {}
};

function DefaultComponent({ className, children }) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}

function withLoader(WrappedComponent = DefaultComponent) {
  function WithLoader(props) {
    const imageUrl = config.app.webAppURL + "/images/list-loader.gif";

    const classes = "p-a p-20 w-100pct h-100pct d-f flex-column jc-center align-center bg-white zi-10";

    function renderLoading() {
      return (
        <div className={classes}>
          <img src={imageUrl}/>
        </div>
      );
    }

    function renderFailed() {
      return (
        <div className={classes}>
          <div className="mb-30 lh-24 c-normalGrey ta-c">
            Não foi possível carregar estas informações.
          </div>
          <a className="fs-14" href="javascript:void(0);" onClick={props.onRetry}>
            Tentar novamente
          </a>
        </div>
      );
    }

    return (
      <WrappedComponent {...props}>
        <div className="p-r w-100pct h-100pct">
          {
            props.loading ? renderLoading() : props.failed && renderFailed()
          }
          { props.children }
        </div>
      </WrappedComponent>
    );
  }

  WithLoader.propTypes = propTypes;
  WithLoader.defaultProps = defaultProps;

  return WithLoader;
}

module.exports = withLoader;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/with-loader.jsx